import { once } from 'lodash';

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const ALPHA_2_PATTERN = /^[A-Z]{2}$/;
const ALPHA_3_ALIASES: Readonly<Record<string, string>> = {
  USA: 'US',
  CAN: 'CA',
  MEX: 'MX',
};

const regionCodesByName = once((): ReadonlyMap<string, string> => {
  const names = new Intl.DisplayNames(['en'], { type: 'region' });
  const codes = new Map<string, string>();
  for (const first of ALPHABET) {
    for (const second of ALPHABET) {
      const code = `${first}${second}`;
      const name = names.of(code);
      if (name !== undefined && name !== code) {
        codes.set(name.toUpperCase(), code);
      }
    }
  }
  return codes;
});

export const toCountryAlpha2 = (country: string | null | undefined): string => {
  const trimmed = (country ?? '').trim();
  const upper = trimmed.toUpperCase();
  if (ALPHA_2_PATTERN.test(upper)) {
    return upper;
  }
  return ALPHA_3_ALIASES[upper] ?? regionCodesByName().get(upper) ?? trimmed;
};
